export default {"src":"/_next/static/media/icon_remove.fa65321f.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};